var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContactsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ContactsSmall_svg__[object_Object]a",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7793FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D576F0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#ContactsSmall_svg__[object_Object]a)",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4E3FE",
    fillRule: "nonzero",
    d: "M16 5a1 1 0 01.993.883L17 6v.776c0 .118.084.22.2.244a1 1 0 01.793.863L18 8v10a1 1 0 01-.883.993L17 19H8.5a1.5 1.5 0 01-1.493-1.356L7 17.5v-11a1.5 1.5 0 011.356-1.493L8.5 5H16zm-3.434 5.001l-.143.001a1.5 1.5 0 00-1.409 1.585c-.044.66.157 1.313.564 1.83.046.123.047.26.004.384l-.417.161c-.777.313-1.222.576-1.416.969-.044.092-.09.246-.137.462a.5.5 0 00.398.599l.09.008h4.8a.5.5 0 00.488-.607l-.056-.228a1.437 1.437 0 00-.08-.231c-.227-.461-.795-.742-1.825-1.127a.54.54 0 01-.013-.377c.412-.52.616-1.178.572-1.843a1.498 1.498 0 00-1.42-1.585zM15.875 6H8.5a.5.5 0 00-.09.992L8.5 7h7.375a.125.125 0 00.119-.085l.006-.04v-.75a.125.125 0 00-.085-.119L15.875 6z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsSmall);
export default ForwardRef;